import {DealPayrollGradeCode} from './deal-payroll.model';

export type CurrencyCode = 'BYN' | 'USD' | 'EUR' | 'CNY';

export const CurrencyCodes = {
  BYN: 'BYN' as CurrencyCode,
  USD: 'USD' as CurrencyCode,
  EUR: 'EUR' as CurrencyCode,
  CNY: 'CNY' as CurrencyCode,
};

export const PAYROLL_CURRENCY_CODES: CurrencyCode[] = [
  CurrencyCodes.BYN,
  CurrencyCodes.USD,
  CurrencyCodes.EUR,
  CurrencyCodes.CNY,
];

export interface CurrencyAmount {
  currency: CurrencyCode;
  amount: number;
}

export type PayrollCurrencySettingField =
  'karmaPointCost'
  | 'attendancePenalty'
  | 'suggestionReward'
  | 'correctAnswerBonus'
  | 'incorrectAnswerPenalty'
  | 'meritPerYear';

export interface PayrollCurrencySetting {
  currency: CurrencyCode;
  karmaPointCost: number;
  attendancePenalty: number;
  suggestionReward: number;
  correctAnswerBonus: number;
  incorrectAnswerPenalty: number;
  meritPerYear: number;
}

export interface PayrollCurrencySettings {
  currencies: PayrollCurrencySetting[];
}

export interface DepartmentPayrollCurrencyUpdateResponse {
  id: string;
  payrollCurrency: CurrencyCode;
}

export interface PayrollCurrencySettingViewField {
  field: PayrollCurrencySettingField;
  labelKey: string;
}

export const PAYROLL_CURRENCY_SETTING_FIELDS: PayrollCurrencySettingViewField[] = [
  { field: 'karmaPointCost', labelKey: 'PAYROLL_CURRENCY_KARMA_POINT_COST' },
  { field: 'attendancePenalty', labelKey: 'PAYROLL_CURRENCY_ATTENDANCE_PENALTY' },
  { field: 'suggestionReward', labelKey: 'PAYROLL_CURRENCY_SUGGESTION_REWARD' },
  { field: 'correctAnswerBonus', labelKey: 'PAYROLL_CURRENCY_CORRECT_ANSWER_BONUS' },
  { field: 'incorrectAnswerPenalty', labelKey: 'PAYROLL_CURRENCY_INCORRECT_ANSWER_PENALTY' },
  { field: 'meritPerYear', labelKey: 'PAYROLL_CURRENCY_MERIT_PER_YEAR' },
];

export interface SalaryContext {
  salaryMonthlyRate?: PayrollMonthlyRate;
  gradeMonthlyRate?: PayrollMonthlyRate;
  gradeMonthlySalary?: number | null;
  payrollCurrency?: CurrencyCode | null;
  gradeCode?: DealPayrollGradeCode | null;
  userId: string;
  salary: number;
  description?: string;
  effectiveCurrency: CurrencyCode;
  inheritedCurrency?: CurrencyCode;
  payrollCurrencyOverride?: CurrencyCode;
  monthlyBonus?: MonthlyBonus;
}

export interface MonthlyBonus {
  amount: number;
  currency: CurrencyCode;
  months?: number;
  effectiveMonth: string;
  revision?: number;
}

export interface PayrollMonthlyRate {
  baseAmount: number;
  bonusAmount: number;
  effectiveAmount: number;
  currency: CurrencyCode;
  month: string;
}

const CURRENCY_NOT_FOUND = -1;
const FINITE_AMOUNT_TYPE = 'number';

export function validMonthlyRate(rate: PayrollMonthlyRate): boolean {
  return !!rate && PAYROLL_CURRENCY_CODES.indexOf(rate.currency) !== CURRENCY_NOT_FOUND && !!rate.month
    && [rate.baseAmount, rate.bonusAmount, rate.effectiveAmount]
      .every(amount => typeof amount === FINITE_AMOUNT_TYPE && isFinite(amount));
}

export interface AdminSalaryUpdateRequest {
  salary: number;
  description?: string;
  payrollCurrencyOverride?: CurrencyCode;
}

export function normalizeCurrencyCode(value?: string): CurrencyCode {
  const currency = value as CurrencyCode;
  return PAYROLL_CURRENCY_CODES.indexOf(currency) === -1
    ? CurrencyCodes.BYN
    : currency;
}

export function trackByCurrencyCode(_index: number, currency: CurrencyCode): CurrencyCode {
  return currency;
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/models/payroll-currency.model.ts